import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconBag2"><Path d="M8.75195 5.25C8.75195 4.83579 9.08774 4.5 9.50195 4.5H14.502C14.9162 4.5 15.252 4.83579 15.252 5.25V7H16.75V21H19.25C20.7688 21 22 19.7688 22 18.25V9.75C22 8.23122 20.7688 7 19.25 7H16.752V5.25C16.752 4.00736 15.7446 3 14.502 3H9.50195C8.25931 3 7.25195 4.00736 7.25195 5.25V7H8.75V21H15.25V7H8.75195V5.25Z" fill="currentColor"/><Path d="M4.75 7H7.25V21H4.75C3.23122 21 2 19.7688 2 18.25V9.75C2 8.23122 3.23122 7 4.75 7Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBag2;
